import {pushUnique} from '~ui/utils';

import {UsersState, UserState} from './slice';

const setUserDetails = (state: UsersState, user: UserState) => {
    state.entities[user.id] = Object.assign({}, state.entities[user.id], user);
    const identity = user.identity.uid || user.identity.cloud_uid;
    if (identity) {
        state.byIdentity[identity] = user.id;
    }

    pushUnique(state.ids, user.id);
};

export {setUserDetails};
